'use strict';

var _ = require('lodash');

/**
 * Set of constants for model validation
 */
exports.constants = {
  NEEDS_QUANTITY_PRICE_TYPES: ['PER_PERSON', 'PER_BOTTLE', 'PER_CAR', 'PER_ITEM']
};

/**
 * Get total cost cents for an addOn, depending on its priceType and its quantity (numGuests). If
 * null, return 0.
 *
 * @param {AddOn} addOn
 * @return {Number}
 */
exports.totalCostCents = function (addOn) {
  if (!addOn.priceInCents || addOn.isDeleted) {
    return 0;
  }

  if (_.includes(exports.constants.NEEDS_QUANTITY_PRICE_TYPES, addOn.priceType) && !addOn.numGuests) {
    return 0;
  }

  if (_.includes(exports.constants.NEEDS_QUANTITY_PRICE_TYPES, addOn.priceType)) {
    return addOn.priceInCents * addOn.numGuests;
  } else if (addOn.priceType === 'FLAT') {
    return addOn.priceInCents;
  } else {
    return 0;
  }
};